// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
// FNP-214: MeterDefinition fields — meterCode (stable code format) + aggregation
// / grain / unit / resetPolicy / purpose / lateness + watermark windows.
import {z} from 'zod';

// Stable code format: lowercase segments separated by dots, e.g. "email.sent",
// "domain.registered". No leading/trailing/double dots, no uppercase, no spaces.
const METER_CODE_PATTERN = /^[a-z0-9]+(\.[a-z0-9]+)*$/;

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    meterCode: z.string()
        .min(1, 'Required')
        .regex(METER_CODE_PATTERN, 'Lowercase, dot-separated (e.g. email.sent)'),
    aggregation: z.string().min(1, 'Required'),
    grain: z.string().min(1, 'Required'),
    // FNP-768: nullish, NOT optional. A meter with no unit stores `unit: null`, and when the
    // edit form seeds the field with that null, `.optional()` (which only permits `undefined`)
    // rejects it with "Expected string, received null" — blocking an otherwise-valid edit of an
    // existing unit-less meter. `.nullish()` accepts both null and undefined. Unit is a genuinely
    // optional display field (no asterisk in the form).
    unit: z.string().nullish(),
    resetPolicy: z.string().min(1, 'Required'),
    purpose: z.string().min(1, 'Required'),
    latenessWindowMinutes: z.coerce.number().int().nonnegative(),
    watermarkDelayMinutes: z.coerce.number().int().nonnegative(),
    status: z.string().min(1, 'Required'),
    // FNP-768: nullish for the same reason — a meter with no dimensions can seed `null` here.
    dimensions: z.array(z.object({
        name: z.string().min(1, 'Required'),
    })).nullish(),
});
